import {
  OWNERSHIP_TYPE,
  LOCATION_TYPE,
  SPONSORED_BY,
  STATION_TYPE,
  SCHOOL_BUILDING,
  BUILDING_TYPE,
  INFRA_FACILITY,
  PM_SHRI_PHASE,
  INTERNET_PLAN,
  INTERNET_CONNECTIVITY,
  CONTACT_ROLE,
  INFRA_SIZE_TYPE,
  INTERNET_TYPE,
  NCC_GROUP,
  NCC_GROUP_WING,
  NCC_GROUP_ANO_CTO,
  NCC_ANO_CTO_RANK,
  RAMP_GROUND_FLOOR,
  INFRA_NAME,
} from '../constants/lookupMaps';

/**
 * Format cell values using lookup maps and special formatting rules
 */
export const formatCellValue = (value: any, key?: string): string => {
  // Handle null/undefined
  if (value === null || value === undefined) {
    return '-';
  }

  // Convert to string for processing
  const strValue = String(value);

  // Helper function to normalize keys (remove spaces, dots, make lowercase)
  const normalizeKey = (k: string) => k.replace(/\s+/g, '').replace(/\./g, '').toLowerCase();

  // Create a lookup mapping with normalized keys
  const lookupByKey: Record<string, Record<number | string, string>> = {
    // Normalize all possible field name variations
    ownershiptype: OWNERSHIP_TYPE,
    locationtype: LOCATION_TYPE,
    sponsoredby: SPONSORED_BY,
    stationtype: STATION_TYPE,
    schoolbuilding: SCHOOL_BUILDING,
    buildingtype: BUILDING_TYPE,
    infrafacility: INFRA_FACILITY,
    pmshreephase: PM_SHRI_PHASE,
    pmshri: PM_SHRI_PHASE,
    pmshree: PM_SHRI_PHASE,
    internetplan: INTERNET_PLAN,
    internetconnectivity: INTERNET_CONNECTIVITY,
    contactrole: CONTACT_ROLE,
    role: CONTACT_ROLE,
    infrasizetype: INFRA_SIZE_TYPE,
    sizetype: INFRA_SIZE_TYPE,
    internettype: INTERNET_TYPE,
    nccgroup: NCC_GROUP,
    nccgroupwing: NCC_GROUP_WING,
    nccgroupanocto: NCC_GROUP_ANO_CTO,
    nccanoctorank: NCC_ANO_CTO_RANK,
    rampInGroundFloor: RAMP_GROUND_FLOOR,
    name: INFRA_NAME,
    infraname: INFRA_NAME,
  };

  // Try to find matching lookup table if key provided
  if (key) {
    const normalizedKey = normalizeKey(key);
    const lookupTable = lookupByKey[normalizedKey];

    if (lookupTable) {
      // Try numeric lookup first
      const numValue = Number(value);
      if (!isNaN(numValue) && lookupTable[numValue] !== undefined) {
        return lookupTable[numValue];
      }
      // Try string lookup
      if (lookupTable[strValue] !== undefined) {
        return lookupTable[strValue];
      }
    }
  }

  // Special handling for PM Shree (backward compatibility)
  if (key && /pmshree|pmshri/i.test(key)) {
    const num = Number(value);
    if (num === 0) return 'No';
    if (num > 0) return `Phase ${num}`;
  }

  // Boolean field detection (fields starting with "is")
  if (key && /^is[A-Z]/.test(key)) {
    const num = Number(value);
    if (num === 0 || value === false || strValue.toLowerCase() === 'false') {
      return 'No';
    }
    if (num === 1 || value === true || strValue.toLowerCase() === 'true') {
      return 'Yes';
    }
  }
   
  // Boolean field for ramp on ground floor
  if (key && normalizeKey(key) === 'rampingroundfloor') {
    const num = Number(value);
    if (num === 0 ) {
      return 'No';
    }
    if (num === 1 ) {
      return 'Yes';
    }
  }

  // Return original value as string
  return strValue;
};
